import window from 'ember-window-mock';

import ENV from 'register-partners-js/config/environment';

const runningOnSubdomain = window.location.href.includes('.dev.qonto.co');
const isAuthenticationShareable = ENV.environment === 'development' && runningOnSubdomain;

let cookieDomain = null;
if (ENV.environment === 'production' && ENV.isStaging) {
  cookieDomain = `.qonto.co`;
} else if (ENV.environment === 'production') {
  cookieDomain = '.qonto.com';
} else if (isAuthenticationShareable) {
  cookieDomain = '.dev.qonto.co';
}

export default cookieDomain;
